import React,{useEffect, useState} from "react"
import { useHistory,useParams } from "react-router"
import styled from "styled-components";
import './Detail.scss';
export default Detail

function Detail(props) {
    let history = useHistory();
    let {id} = useParams();
    let 찾은상품 = props.shoes.find(x => x.id == id);
    let [alertState,alertState변경] = useState(true);
    let [inputData,inputData변경] = useState();

    useEffect(()=>{
        let 타이머 = setTimeout(() => {
            alertState변경(false);
        }, 2000);
        //console.log("안녕");
        return ()=>{
            clearTimeout(타이머);
        }
    },[]);


    let 박스 = styled.div`
        padding-top : 30px;        
    `;
    let 제목 = styled.h4`
        font-size : 25px;
        color : ${ props => props.색상}
    `;
    return (
        <div className="container">
            
           <박스>
                <제목 className="red">Detail</제목>
           </박스>
            {inputData}
           <input onChange={(e)=>{inputData변경(e.target.value)}}></input>
           {
                alertState ?
                    <div className="my-alert">
                        <p>재고가 얼마 남지 않았습니다.</p>
                    </div>
                    : null
           }
           
            <div className="row">
                <div className="col-md-6">
                    <img src={"https://codingapple1.github.io/shop/shoes"+(찾은상품.id+1)+".jpg"} width="100%" />
                </div>
                <div className="col-md-6 mt-4">
                    <h4 className="pt-5">{찾은상품.title}</h4>
                    <p>{찾은상품.content}</p>
                    <p>{찾은상품.price}</p>
                    {<Info 재고 = {props.재고[id]}></Info>}
                    <button className="btn btn-danger">주문하기</button>
                    <button className="btn btn-danger" onClick={() => { history.goBack() }}>뒤로가기</button>
                </div>
            </div>
        </div>
    )
}

function Info(props){
    return(
        <p>재고 : {props.재고}</p>
    );
}